import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiHandle, baseURL } from "../config/apiHandle/apiHandle";
import { type_constant } from "../utils/asyncStatus";

export const getChatUsersListAsync = createAsyncThunk(
  type_constant.GET_CHATS,
  async () => {
    try {
      const response = await apiHandle.get(`/chat-users`);
      const res_data = await response.data;
      return res_data;
    } catch (error) {
      console.log("ERROR FROM GET CHAT USERS LIST =======>>>>>", error);
      if (error?.response?.data) {
        throw Error(error.response.data.message);
      } else {
        throw Error(error.message);
      }
    }
  }
);

// Send email notification when a message is sent
export const sendMessageNotification = async (receiverId, message) => {
  console.log("=== Sending Email Notification ===");
  console.log("Receiver ID:", receiverId);
  console.log("Message:", message);

  try {
    const response = await apiHandle.post(`/send-message-notification`, {
      receiver_id: receiverId,
      message: message,
    });
    console.log("✅ Email notification SUCCESS:", response.data);
    return response.data;
  } catch (error) {
    console.log("❌ Email notification FAILED:");
    console.log("Error status:", error?.response?.status);
    console.log("Error message:", error?.response?.data?.message || error.message);
    console.log("Full error:", error?.response?.data || error);
    // Don't throw - this is a non-critical operation
    return null;
  }
};

// Fetch old messages from backend database
export const fetchOldMessages = async (userId1, userId2) => {
  console.log("📥 Fetching old messages from backend");
  console.log("User 1:", userId1, "User 2:", userId2);

  try {
    const response = await apiHandle.get(`/messages/${userId1}/${userId2}`);
    console.log("✅ Old messages fetched:", response.data);
    return response.data?.messages || response.data || [];
  } catch (error) {
    console.log("❌ Failed to fetch old messages:");
    console.log("Error:", error?.response?.data?.message || error.message);
    // Return empty array if endpoint doesn't exist or fails
    return [];
  }
};
